// BCP-47 locale validation, mirroring the backend gate
// (address-book-api src/schemas/translations.ts: BCP47_PATTERN + Intl.Locale).
// The backend remains the authority; this is UX-level early validation.
const BCP47_PATTERN = /^[a-zA-Z]{2,3}(-[a-zA-Z0-9]{2,8})*$/;

export function isValidLocale(code: string): boolean {
  const trimmed = code.trim();
  if (!BCP47_PATTERN.test(trimmed)) {
    return false;
  }
  try {
    new Intl.Locale(trimmed);
    return true;
  } catch {
    return false;
  }
}
